<span *ngIf="text.length <= wordLimit">{{text}}</span>

<span *ngIf="text.length > wordLimit && !showMore">
  {{text.substring(0,wordLimit)}}... <span class="font-bold cursor-pointer" (click)="showMore=true">show more</span>
</span>

<span *ngIf="text.length > wordLimit && showMore">
  {{text}} <span class="font-bold cursor-pointer" (click)="showMore=false">show less</span>
</span>